import * as React from "react";
export class Heading extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-racing-next-races__header" },
            React.createElement("span", { className: "rj-racing-next-races__title" }, this.props.title)));
    }
}
//# sourceMappingURL=Heading.js.map